import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { material } from '../../../library/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { saveOnboardingDocument } from '../../../services/on-boarding-service/OnBoardingService';
import Snackbar from '../../toastrmessage/Snackbar';

const documentName = [];

function DocumentUpload(props) {
    const { register } = useForm({ mode: "onTouched" });
    const navigate = useNavigate();
    const location = useLocation();
    const formDetails = location.state?.formDetails;

    const [openSnackBar, setOpenSnackBar] = useState({
        action: false,
        type: "",
        message: "",
    });
    const [errors, setErrors] = useState({});
    const [selectedFiles, setSelectedFiles] = useState({});
    const [documentType, setDocumentType] = useState([]);

    const fields = [
        { name: "ahpraRegistration", label: "AHPRA Registration (allow only PDF)", docType: "AHPRA_REG" },
        { name: "insuranceDetails", label: "Insurance Details (allow only PDF)", docType: "INSURANCE" },
        { name: "firstAid", label: "First Aid Certificate (allow only PDF)", docType: "FIRST_AID" },
        { name: "additional", label: "Additional (allow only PDF)", docType: "ADDITIONAL" },
    ];
    // formDetails?.role === "PRESCRIBER"
    //     ? [
    //         { name: "ahpraRegistration", label: "AHPRA Registration", docType: "AHPRA_REG" },
    //         { name: "insuranceDetails", label: "Insurance Details", docType: "INSURANCE" },
    //         { name: "abn", label: "[If applicable] an ABN", docType: "ABN" },
    //         { name: "additional", label: "Additional", docType: "ADDITIONAL" },
    //     ]
    //     : formDetails?.role === "ADMIN"
    //         ? [
    //             { name: "ahpraRegistration", label: "AHPRA Registration", docType: "AHPRA_REG" },
    //             { name: "insuranceDetails", label: "Insurance Details", docType: "INSURANCE" },
    //             { name: "firstAid", label: "First Aid Certificate", docType: "FIRST_AID" },
    //             { name: "additional", label: "Additional", docType: "ADDITIONAL" },
    //         ]
    //         : [];

    const validateFile = (files) => {
        if (!files || files.length === 0) {
            return "This field is required.";
        }

        if (!Array.from(files).every((file) => file.type === "application/pdf")) {
            return "Only PDF files are allowed.";
        }
        return null;
    };

    const handleFileChange = (fieldName, files) => {
        const error = validateFile(files);
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: error,
        }));

        if (!error) {
            setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [fieldName]: files,
            }));
        }
    };

    const handleFileUpload = (fieldName) => {
        const files = selectedFiles[fieldName];
        const error = validateFile(files);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: error,
        }));
        if (error) {
            return;
        }
        const field = fields.find((f) => f.name === fieldName);
        const docType = field?.docType;
        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append("files", file);
        });
        formData.append("document_type", docType);
        formData.append("formId", formDetails.formId);

        saveOnboardingDocument(formData)
            .then((resp) => {
                documentName.push(docType);
                setDocumentType(documentName);
                setOpenSnackBar({
                    action: true,
                    type: "success",
                    message: resp.data,
                });
            })
            .catch((error) => {
                setOpenSnackBar({
                    action: true,
                    type: "error",
                    message: error.response?.data?.message,
                });
            });
    };

    return (
        <div>
            <div style={{ display: "flex", width: "100%", height:"100vh", justifyContent: "center", alignItems: "center" }}>
                <material.Paper elevation={3} sx={{ width: { xs: "90%", sm: "70%", md: "40%" }, height: "auto", p: 2 }}>
                    <material.Typography variant='h6' sx={{ mt: 3, textAlign: 'center' }}>
                        Please upload all documents and close the tab.
                    </material.Typography>
                    <form>
                        {fields.map((field) => (
                            <material.Grid container spacing={2} key={field.name}>
                                <material.Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <material.FormGroup>
                                        <material.FormControlLabel
                                            control={<material.Checkbox checked={documentType.includes(field.docType)} color='success' />}
                                            label="Uploaded"
                                        />
                                    </material.FormGroup>
                                </material.Grid>
                                <material.Grid item xs={12} sm={6}>
                                    <material.InputLabel>{field.label}</material.InputLabel>
                                    <input
                                        type="file"
                                        multiple
                                        {...register(field.name)}
                                        name={field.name}
                                        onChange={(e) => handleFileChange(field.name, e.target.files)}
                                        style={{ width: '100%' }}
                                    />
                                    {errors[field.name] && (
                                        <p style={{ color: "red", fontSize: "0.9rem" }}>
                                            {errors[field.name]}
                                        </p>
                                    )}
                                </material.Grid>
                                <material.Grid item xs={12} sm={3}>
                                    <material.Button
                                        variant="contained"
                                        sx={{ textTransform: "none", width: '100%' }}
                                        startIcon={<material.UploadIcon />}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleFileUpload(field.name);
                                        }}
                                    >
                                        Upload
                                    </material.Button>
                                </material.Grid>
                            </material.Grid>
                        ))}
                    </form>
                </material.Paper>
            </div>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    );
}


export default DocumentUpload;